import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'urlsToAnchors',
})
export class UrlsToAnchorsPipe implements PipeTransform {
  transform(value: string, target = '_blank', className = 't-link'): string {
    // Match http and https URLs
    const pattern1 =
      /(\b(https?|ftp):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gim;
    const anchor1 = `<a href="$1" target="${target}" class="${className}">$1</a>`;
    let formattedString = value.replace(pattern1, anchor1);

    // Match www URLs
    const pattern2 = /(^|[^/])(www\.[\S]+(\b|$))/gim;
    const anchor2 = `$1<a href="http://$2" target="${target}" class="${className}">$2</a>`;

    formattedString = formattedString.replace(pattern2, anchor2);

    return formattedString;
  }
}
